import { gql } from "@apollo/client";

const REMOVE_PAYMENT_METHOD = gql`
  mutation RemovePaymentMethod($paymentMethodId: String!) {
    deletePaymentMethod(input: { paymentMethodId: $paymentMethodId }) {
      paymentMethod {
        id
        deleted
      }
    }
  }
`;

export default REMOVE_PAYMENT_METHOD;
